import { hbs } from 'ember-cli-htmlbars';
export default hbs("<section\n  class={{join-classes \'section\' (if (eq @gap \'small\') \'section--gap-small\')}}\n  ...attributes\n>\n  {{yield}}\n</section>")